import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgAddToCart({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.5 19a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm8 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM3.138 2a3 3 0 012.975 2.613l.017.173.735 10.285a1 1 0 00.886.923l.111.006h7.784a1 1 0 00.877-.519l.051-.11.595-1.485A6 6 0 0110 8H9a1 1 0 01-.117-1.993L9 6h1.341A6.002 6.002 0 0122 8a5.988 5.988 0 01-2.17 4.619l-1.399 3.495a3 3 0 01-2.593 1.88l-.192.006H7.862a3 3 0 01-2.975-2.613l-.017-.173-.735-10.285a1 1 0 00-.886-.923L3.138 4H3a1 1 0 01-.117-1.993L3 2h.138zM16 4a4 4 0 100 8 4 4 0 000-8zm0 1a1 1 0 011 1v1h1a1 1 0 010 2h-1v1a1 1 0 01-2 0V9h-1a1 1 0 110-2h1V6a1 1 0 011-1z"
        fill={color}
      />
    </svg>
  )
}

export default SvgAddToCart
